import { Injectable } from '@angular/core';
import {Router} from '@angular/router';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {ServiceConfig} from './service-config';
import {HttpClient} from '@angular/common/http';
@Injectable()
export class AccountsService {

  private host = ServiceConfig.host;
  private baseUrl = this.host + '/api/accounts/';
  // public baseUrl = 'http://localhost/api/accounts/';
  private data: any;
  private headers: Headers;
  private options: {};

  constructor(private http: HttpClient,
              private router: Router) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    // console.log(this.data.token);
    this.headers = new Headers({
      'Content-Type': 'application/json'
    });
    this.options = {headers: this.headers};
  }

  public index() {
    let url = this.baseUrl + '?token=' + this.data.token;
    return this.http.get<any>(url);
  }

  public getAccountByDepartment() {
    let url = this.host + `/api/account/accounts?token=` + this.data.token;
    return this.http.get<any>(url);
  }

  // lấy các tài khoản thuộc phòng ban online
  public getAccountListOnline() {
    let url = this.baseUrl + `/getAccountListOnline?token=` + this.data.token;
    return this.http.get<any>(url);
  }

  public getListKtv() {
    let url = this.baseUrl + 'getListKtv?token=' + this.data.token;
    return this.http.get<any>(url);
  }

  public create(body) {
    let url = this.baseUrl + 'create?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public get(username: String) {
    let url = this.baseUrl + username + '?token=' + this.data.token;
    return this.http.get<any>(url);
  }

  public update(username: String, body) {
    let url = this.baseUrl + username + '/update?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public delete(username: String, body) {
    let url = this.baseUrl + username + '/delete?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public changePassword(username: String, body) {
    let url = this.baseUrl + username + '/change_password?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public updateMany(action: String, body){
    let url = this.baseUrl + action + '/updateMany?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  // badv: lấy tất cả các account đang có permission truyền vào
  public findAccountsByPermission(permissionId: String){
    let url = this.baseUrl + permissionId + '/findAccountsByPermission?token=' + this.data.token;
    return this.http.post<any>(url, this.options);
  }

  public updateStatus(body) {
    const url = this.baseUrl + 'updateStatus?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public findAccountsByDepartment(body) {
    const url = this.baseUrl + `accounts-department?token=` + this.data.token;
    return this.http.post<any>(url, body);
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/accounts.service.ts